import { CONSULTATION_TYPE } from '@abiglobalhealth/go-types'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import { swapConsultation } from '@/api/consultations'
import { Button } from '@/components/Button'
import { useConsultation } from '@/hooks/useConsultation'
import { useConsultationType } from '@/hooks/useConsultationType'
import { useLoading } from '@/hooks/useLoading'
import { useUser } from '@/hooks/useUser'
import { getSlugTranslation } from '@/locale/utils'

import VideoWarningIcon from './icons/VideoWarningIcon'

export const WaitingForSwap = () => {
  const { t } = useTranslation()
  const { user } = useUser()
  const { updateConsultation } = useConsultation()
  const { consultationType, setConsultationType } = useConsultationType()
  const { showLoading, hideLoading, loading } = useLoading()

  const handleButtonClick: Dispatch<SetStateAction<string | null>> = async (to) => {
    showLoading()
    try {
      const consultationInfo = await swapConsultation({
        uniqueId: user?.data?.uniqueId!,
        to: to as CONSULTATION_TYPE
      })
      if (consultationInfo.consultationType !== consultationType) {
        setConsultationType(consultationInfo.consultationType)
      }
      updateConsultation(consultationInfo)
    } finally {
      hideLoading()
    }
  }

  if (loading) return null

  return (
    <div className="flex flex-1 flex-col items-center gap-6 p-4" data-testid="ending-container">
      <div className="py-9 text-center" data-testid="prescription-warning-icon-container">
        <VideoWarningIcon />
      </div>
      <p
        dangerouslySetInnerHTML={{
          __html: getSlugTranslation('switch.generic')
        }}
      />

      <div className="flex w-full flex-col">
        <Button onClick={() => handleButtonClick(CONSULTATION_TYPE.VIDEO)} customClassName="flex gap-4 items-center justify-center w-full bg-success">
          {t('switch.to_video.button')}
        </Button>

        <a href={'#'} className="text-primary pt-9 text-center font-bold" onClick={() => handleButtonClick(CONSULTATION_TYPE.MEDICAL)}>
          {t('switch.continue_text')}
        </a>
        <p className="text-gray-text text-center text-sm">{t('switch.no_prescription')}</p>
      </div>
    </div>
  )
}
